import ExportadorFichajesDetallados from "components/exportaciones/ExportadorFichajesDetallados";
import ExportadorHorasExtra from "components/exportaciones/ExportadorHorasExtra";
import ExportadorTrazabilidadFichajes from "components/exportaciones/ExportadorTrazabilidadFichajes";
import ExportarFichajes from "components/exportaciones/ExportarFichajes";
import React from "react";
import { Col, Row } from "reactstrap";

const ViewExportaciones = () => {
  return (
    <>

      <Row className="mb-2">
        <Col >
          <ExportarFichajes></ExportarFichajes>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col>
          <ExportadorFichajesDetallados></ExportadorFichajesDetallados>
        </Col>
      </Row> 
      <Row className="mb-2">
        <Col>
          <ExportadorHorasExtra></ExportadorHorasExtra>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col>
          <ExportadorTrazabilidadFichajes></ExportadorTrazabilidadFichajes>
        </Col>
      </Row>
    </>
  );
};

export default ViewExportaciones;
